import { render, staticRenderFns } from "./doctorConsultDetails.vue?vue&type=template&id=4021b020&scoped=true"
import script from "./doctorConsultDetails.vue?vue&type=script&lang=js"
export * from "./doctorConsultDetails.vue?vue&type=script&lang=js"
import style0 from "./doctorConsultDetails.vue?vue&type=style&index=0&id=4021b020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021b020",
  null
  
)

export default component.exports